
import {Tabs} from 'antd-mobile' 
import { tabs } from './data'
import { useNavigate } from 'react-router-dom'
import styles from './styles.module.scss'

export const HeaderTabs = ({actived}: {actived: string}) => {
  const navidate = useNavigate();
  const onchange = (key: string) => {
    const tab = tabs.find(tab => tab.key === key);
    if(tab){
      navidate(tab.url,{replace: true})
    }
  }
  return <div className={styles.pageHeaderTabs}>
    <Tabs activeKey={actived} onChange={onchange}>
    {
      tabs.map(item => (
        <Tabs.Tab key={item.key} title={item.title}></Tabs.Tab>
      ))
    }
  </Tabs>

  </div>
}

